module.exports = __webpack_public_path__ + "media/match-started.8e6a034b.mp3";